/* eslint-disable no-undef */
import axios from 'axios'

const appkey = process.env.REACT_APP_KEY
const lopDn = process.env.REACT_APP_LOP_DN
const service = axios.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'LOP-DN': lopDn,
    app_key: appkey,
    v: 2.0
  },
  timeout: 60000,
  withCredentials: true // 跨域时需要带上cookie需要开启
})

// Request 拦截
service.interceptors.request.use((config) => {
  if (config.method === 'get' && config.params && config.params.length) {
    Object.keys(config.params).forEach((key) => {
      if (config.params[key]) {
        encodeURIComponent(key)
        encodeURIComponent(config.params[key])
      }
    })
  }

  return config
})

// Response 拦截
service.interceptors.response.use(
  (response) => {
    const { data } = response
    if (response.config.url.indexOf('/oidc/authorize') > -1) {
      return Promise.resolve(data)
    }

    const res = response.data
    if (response.headers.type === 'downLoad') {
      return res
    }

    if (res.code !== 200) {
      if (res.code === 300) {
        window.location.replace(`${window.location.origin}/#/noAuth`)
        return null
      }
      return Promise.reject(res)
    }
    if (res.code === 200) {
      if (res.result || res.result === 0) {
        return res.result
      }
      return res.data
    }
    return Promise.reject(res)
  },
  (error) => Promise.reject(error)
  // (error) => {
  // let message
  // let title
  // if (error.response && error.response.status) {
  //   if (error.response.status === 401) {
  //     const { headers, config } = error.response
  //     const { location } = headers
  //     return service.get(location)
  //       .then(res => {
  //         // response 登录校验
  //         if (res.data) {
  //           const { type, value } = res.data
  //           if (type === 'RETURN_URL') {
  //             window.location.href = value
  //           } else if (type === 'OIDC_CODE') {
  //             // 缓存oidc.code 重新发起请求
  //             const configFoo = {
  //               ...config // 真正的业务服务
  //             }
  //             if (configFoo.params) {
  //               // 此处oidc.code参数名称与后端配置的参数oauth2ParamPrefixPolicy=Oidc配合使用
  //               configFoo.params['oidc.code'] = value
  //             } else {
  //               configFoo.params = { 'oidc.code': value }
  //             }
  //             return service.request(configFoo)
  //           } else {
  //             console.log('oidc.code获取失败')
  //           }
  //         }
  //         return true
  //       })
  //   }
  //   try {
  //     message = error.response.data.data.message
  //     title = `${error.response.data.data.error} ${error.response.status}`
  //   } catch {
  //     message = '请求出错!'
  //     title = error.response.status
  //   }
  //   console.log(title, message)
  //   return Promise.reject(error)
  // }
  // return Promise.reject(error)
  // }
)

export default service
